import { DeepUpLogoFull } from '@deepup/icons';
import { useAppDispatch } from '@core/redux/hooks';
import { projectsHistoryActions, projectsHistorySelectors } from '@menu/redux';
import { AppBar, Toolbar } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConmonLink } from './ConmonLink';
import { IssueReporting } from './IssueReporting';
import { MenuButton } from './MenuButton';
import { useIssueReportingEnabled } from './useIssueReportingEnabled';
import { UserAccount } from './UserAccount';

export const MenuBar = () => {
  const pinnedProjects = useSelector(projectsHistorySelectors.selectPinnedProjects);
  const recentProjects = useSelector(projectsHistorySelectors.selectRecentProjects);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const showAdditionalMenuItem = /^\/projects\/(?!list\b)[^/]+/.test(location.pathname);

  const { isIssueReportingEnabled } = useIssueReportingEnabled();

  const handleLogoClick = () => {
    navigate('/projects/list');
  };

  useEffect(() => {
    dispatch(projectsHistoryActions.loadProjectsHistory());
  }, []);

  return (
    <AppBar position="sticky" sx={(theme) => ({ zIndex: theme.zIndex.modal })}>
      <Toolbar variant="dense" sx={{ display: 'flex', gap: 1 }}>
        <DeepUpLogoFull
          width={80}
          height="auto"
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        />
        <MenuButton
          id="projects-menu"
          title="Projects"
          recentItems={recentProjects.map(({ title, id }) => ({
            title,
            href: `/projects/${id}`,
            id,
          }))}
          pinnedItems={pinnedProjects.map(({ title, id }) => ({
            title,
            href: `/projects/${id}`,
            id,
          }))}
        />
        <div style={{ flexGrow: 1 }} />
        {showAdditionalMenuItem && (
          <>
            <ConmonLink />
            {isIssueReportingEnabled && <IssueReporting />}
          </>
        )}
        <UserAccount />
      </Toolbar>
    </AppBar>
  );
};
